const SBC_MOBILE_MQ = '(max-width: 989px)';

class ShopByCategoryScroll {
  constructor(section) {
    this.section = section;
    this.scroller = section.querySelector('[data-sbc-scroll]');
    this.progressFill = section.querySelector('[data-sbc-progress-fill]');
    this.mobileScrollEnabled = section.dataset.sbcMobileScroll === 'true';
    this.showProgress = section.dataset.sbcShowProgress === 'true';

    if (!this.scroller || !this.mobileScrollEnabled) return;

    this.mobileMq = window.matchMedia(SBC_MOBILE_MQ);
    this.onScroll = this.onScroll.bind(this);
    this.onMqChange = this.onMqChange.bind(this);

    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
    this.mobileMq.addEventListener('change', this.onMqChange);

    this.resizeObserver = new ResizeObserver(() => this.updateProgress());
    this.resizeObserver.observe(this.scroller);

    this.updateProgress();
    window.addEventListener('load', () => this.updateProgress());
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => this.updateProgress());
    }
  }

  get isActive() {
    return this.mobileMq.matches && this.mobileScrollEnabled;
  }

  onMqChange() {
    this.updateProgress();
  }

  onScroll() {
    this.updateProgress();
  }

  updateProgress() {
    if (!this.showProgress || !this.progressFill || !this.isActive) return;

    const scrollWidth = this.scroller.scrollWidth;
    const clientWidth = this.scroller.clientWidth;
    if (!scrollWidth || !clientWidth) return;

    const maxScroll = Math.max(0, scrollWidth - clientWidth);
    if (maxScroll <= 0) {
      this.progressFill.style.width = '100%';
      this.progressFill.style.transform = 'translateX(0)';
      return;
    }

    const visibleRatio = Math.min(clientWidth / scrollWidth, 1);
    const widthPct = Math.max(visibleRatio * 100, 12);
    let ratio = Math.min(this.scroller.scrollLeft / maxScroll, 1);
    if (maxScroll - this.scroller.scrollLeft < 1) ratio = 1;

    this.progressFill.style.width = `${widthPct}%`;

    const trackWidth = this.progressFill.parentElement.clientWidth;
    const fillWidth = this.progressFill.offsetWidth;
    const travelPx = Math.max(trackWidth - fillWidth, 0);
    this.progressFill.style.transform = `translateX(${ratio * travelPx}px)`;
  }

  destroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }
}

function initShopByCategoryScroll(root = document) {
  const sections = root.matches?.('[data-shop-by-category-scroll]')
    ? [root]
    : Array.from(root.querySelectorAll('[data-shop-by-category-scroll]'));

  sections.forEach((section) => {
    if (section._sbcScrollInstance) {
      section._sbcScrollInstance.destroy();
    }

    section._sbcScrollInstance = new ShopByCategoryScroll(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShopByCategoryScroll);
} else {
  initShopByCategoryScroll();
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target;
  const section =
    root.matches?.('[data-shop-by-category-scroll]')
      ? root
      : root.querySelector?.('[data-shop-by-category-scroll]');

  if (section) {
    initShopByCategoryScroll(section);
  }
});
